<template>
  <div class="flex flex-col items-start pt-6 px-6 pb-4" :class="customClasses">
    <div
      ref="modalHeaderTitle"
      class="text-primary text-lg leading-[24px] font-semibold dark:text-slate-100 flex items-center gap-2 mb-0"
    >
      <slot name="titleIcon">
        <span class="material-symbols-outlined text-icon-primary">
          {{ headerTitleIcon }}
        </span>
      </slot>
      {{ headerTitle }}
    </div>
    <div
      v-if="headerContent"
      ref="modalHeaderContent"
      class="w-full break-words !text-gray-600 mt-2 text-sm dark:text-gray-300"
    >
      <div v-html="headerContent" />
      <div
        v-if="headerContentValue"
        class="font-semibold text-sm !text-gray-600 dark:text-gray-300"
      >
        {{ headerContentValue }}
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
    headerTitleIcon: {
      type: String,
      default: 'add'
    },
    headerContentValue: {
      type: String,
      default: '',
    },
    customClasses: {
      type: String,
      default: '',
    },
  },
};
</script>
